module.exports = __webpack_public_path__ + "static/media/solution-measure.5cf44812.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/solution-measure.svg
// module id = 21
// module chunks = 6